.pageWrapper {
  width: 100%;
  min-height: 100vh;
}

.card {
  width: 100%;
  max-width: 420px;
  box-shadow: 0 4px 24px rgba(13, 27, 42, 0.08);
}

.card :global(.ant-card-body) {
  padding: 40px 44px;
}

.brand {
  margin-bottom: 24px;
}

.iconWrap {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: rgba(0, 191, 165, 0.1);
  flex-shrink: 0;
}

.brandIcon {
  font-size: 24px !important;
  color: #00bfa5 !important;
}

.brandName {
  font-size: 17px !important;
  font-weight: 700 !important;
  color: #1a2d3f !important;
  line-height: 1.2 !important;
}

.brandTag {
  font-size: 11px !important;
  color: #637889 !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-top: 1px;
}

.divider {
  margin: 0 0 24px !important;
}

.heading {
  font-size: 20px !important;
  font-weight: 700 !important;
  color: #1a2d3f !important;
  margin: 0 0 4px !important;
  letter-spacing: -0.2px;
}

.subHeading {
  font-size: 13px !important;
  color: #637889 !important;
  display: block;
}

.form {
  margin-top: 24px;
}

.label {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #637889 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.submitFormItem {
  margin-top: 8px;
}

.errorAlert {
  margin-top: 16px;
}
